import { Application } from 'stimulus';
import ModuleAttributeSetFormFieldsController from './controllers/components/ModuleAttributeSetFormFieldsController';
import ModuleFormFieldsController from './controllers/components/ModuleFormFieldsController';
import RegularTeachersFormController from './controllers/components/RegularTeachersFormController';
import LessonTimesFormController from './controllers/components/LessonTimesFormController';
import DefaultLessonSubsourcesFormController from './controllers/components/DefaultLessonSubsourcesFormController';
import AutoselectInputController from './controllers/components/AutoselectInputController';
import ExpandPreviewController from './controllers/components/ExpandPreviewController';
import AddEditLessonController from './controllers/AddEditLessonController';
import LessonFeedbackRadioController from './controllers/LessonFeedbackRadioController';
import LessonVocabFeedbackController from './controllers/LessonVocabFeedbackController';
import PinyinInputController from './controllers/PinyinInputController';
import AutosizeTextareaController from './controllers/AutosizeTextareaController';
import VocabExportController from './controllers/VocabExportController';
import LessonVocabSubmitController from './controllers/LessonVocabSubmitController';
import ModuleBundlesController from './controllers/ModuleBundlesController';

import PinyinToolbox from './components/PinyinToolbox';
import reactDom from 'react-dom';
import * as React from 'react';
import * as Sentry from '@sentry/browser';

// only init sentry if we're not running locally
if (window.location.href.indexOf('localhost') === -1) {
  Sentry.init({ dsn: 'https://7ce27a8bb5ee4e868b2000f9b32dedeb@sentry.io/2614726' });
}

const app = Application.start();
app.register('components--regularTeachersForm', RegularTeachersFormController);
app.register('components--lessonTimesForm', LessonTimesFormController);
app.register('components--defaultLessonSubsourcesForm', DefaultLessonSubsourcesFormController);
app.register('components--autoselectInput', AutoselectInputController);
app.register('components--moduleAttributeSetFormFields', ModuleAttributeSetFormFieldsController);
app.register('components--moduleFormFields', ModuleFormFieldsController);
app.register('components--expandPreview', ExpandPreviewController);

app.register('addEditLesson', AddEditLessonController);
app.register('lessonFeedbackRadio', LessonFeedbackRadioController);
app.register('lessonVocabFeedback', LessonVocabFeedbackController);
app.register('pinyinInput', PinyinInputController);
app.register('autosizeTextarea', AutosizeTextareaController);
app.register('vocabExport', VocabExportController);
app.register('lessonVocabSubmit', LessonVocabSubmitController);
app.register('moduleBundles', ModuleBundlesController);

// react mount points
// add a div with data-react-mount="you-mount-point" to have it auto-mount on load

const mountPoints: { [key: string]: any } = {
  PinyinToolbox,
};

document.querySelectorAll('[data-react-mount]').forEach((elm: HTMLElement) => {
  const mountPoint = elm.dataset.reactMount;
  if (!mountPoints[mountPoint]) throw new Error(`Could not find mount point ${mountPoint}`);
  reactDom.render(React.createElement(mountPoints[mountPoint], null, null), elm);
});
